"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const socket_io_client_1 = require("socket.io-client");
const webChat_1 = __importDefault(require("./webChat"));
const store_1 = __importDefault(require("./store"));
const Tomato = (props) => {
    const { url, imageSize, secretKey, } = props;
    const [socket, setSocket] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setSocket((0, socket_io_client_1.io)(url, {
            transports: ['websocket']
        }));
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, socket !== null &&
        react_1.default.createElement(store_1.default, null,
            react_1.default.createElement(webChat_1.default, { socket: socket, config: {
                    imageSize,
                    secretKey,
                } }))));
};
exports.default = Tomato;
